export enum TripServiceTaxation {
	iva_assolta = "IVA ASSOLTA",
	iva_art_15 = 'IVA art.15',
	iva_5 = "IVA 5%",
	iva_10 = "IVA 10%",
	iva_20 = "IVA 20%",
	iva_22 = "IVA 22%"
}
